import React, { useState, useEffect } from "react";

import Request from "../../core/httpClient";
import CommonAreaForm from "./CommonAreaForm";
const request = new Request();

// Parse robusto: acepta array u objeto/string JSON y compara selected de forma flexible
// (algunos endpoints regresan selected como 1 y otros como "1").
const parseSeleccionados = (raw) => {
	let seleccionados = [];
	if (Array.isArray(raw)) {
		seleccionados = raw;
	} else if (typeof raw === "string") {
		try {
			seleccionados = JSON.parse(raw);
		} catch (e) {
			seleccionados = [];
		}
	}
	if (!Array.isArray(seleccionados)) {
		return [];
	}
	return seleccionados
		.filter((sub) => Number(sub.selected) === 1)
		.map((sub) => sub.id_subfraccionamiento.toString());
};

const CommonAreasEdit = ({ area, subfraccionamientos, subLabel, updateData }) => {
	const [state, setState] = useState({
		showModal: false,
		nombre: area.nombre,
		descripcion: area.descripcion,
		activo: area.activo,
		id: area.id_espacio,
		categoria: area.id_categoria,
		diasPrevios: area.dias_reserva,
		minutosPrevios: area.minutos_previos_reserva,
		fianza: area.fianza,
		tiempoDisponible: area.dias_maximos_reserva ? area.dias_maximos_reserva : area.horas_maximas_reserva,
		isDiasDisponible: area.dias_maximos_reserva ? true : false,
		imagenArea: area.area_imagen || "",
		// idSubfrac se mantiene INTACTO con su valor original (no lo tocan los checkboxes).
		idSubfrac: area.id_subfraccionamiento,
		// subfraccionamientosSeleccionados es lo que controlan los checkboxes.
		subfraccionamientosSeleccionados: parseSeleccionados(area.subfraccionamientosSeleccionados),
		subfraccionamientos,
		categories: [],
		anuales: area.max_reservas_anual,
		mensuales: area.max_reservas_mensual,
		diarias: area.max_reservas_diaria,
		consecutivas: area.max_reservas_consecutivas,
		aforo: area.max_aforo || 1,
		pausar: area.pausar !== null && area.pausar !== 0 ? 1 : 0,
		motivo: area.motivo || "",
		aforoMax: area.max_aforo !== null ? true : false,
		maXVivienda: area.max_reservas_aforo !== null ? area.max_reservas_aforo : 1,
		subLabel
	});

	// Helper para actualizar estado y notificar al padre
	const handleUpdate = (data) => {
		// Solo normalizamos la selección de los checkboxes. idSubfrac no se toca.
		if (data.subfraccionamientosSeleccionados) {
			data.subfraccionamientosSeleccionados = Array.isArray(data.subfraccionamientosSeleccionados)
				? data.subfraccionamientosSeleccionados.map(id => id.toString())
				: [data.subfraccionamientosSeleccionados.toString()];
		}
		updateData(data);
		setState((prev) => ({ ...prev, ...data }));
	};

	// Sincroniza cuando cambia el área a editar O cuando llega la lista de
	// subfraccionamientos (evita la carrera que hacía que a veces no se pintara).
	useEffect(() => {
		const seleccion = parseSeleccionados(area.subfraccionamientosSeleccionados);

		setState((prev) => ({
			...prev,
			id: area.id_espacio,
			nombre: area.nombre,
			descripcion: area.descripcion,
			activo: area.activo,
			categoria: area.id_categoria,
			diasPrevios: area.dias_reserva,
			minutosPrevios: area.minutos_previos_reserva,
			fianza: area.fianza,
			tiempoDisponible: area.dias_maximos_reserva ? area.dias_maximos_reserva : area.horas_maximas_reserva,
			isDiasDisponible: area.dias_maximos_reserva ? true : false,
			imagenArea: area.area_imagen || "",
			idSubfrac: area.id_subfraccionamiento, // se mantiene INTACTO
			subfraccionamientosSeleccionados: seleccion, // lo que pintan los checkboxes
			subfraccionamientos,
			anuales: area.max_reservas_anual || "",
			mensuales: area.max_reservas_mensual || "",
			diarias: area.max_reservas_diaria || "",
			consecutivas: area.max_reservas_consecutivas || "",
			aforo: area.max_aforo || 1,
			aforoMax: area.max_aforo !== null ? true : false,
			maXVivienda: area.max_reservas_aforo !== null ? area.max_reservas_aforo : 1,
			pausar: area.pausar,
			motivo: area.motivo || ""
		}));



		updateData({ subfraccionamientosSeleccionados: seleccion });

		if (area.area_imagen) {
			base64ToUrl({ area_imagen: area.area_imagen, id_area: area.id_espacio });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [area, subfraccionamientos]);

	// Función para cargar categorías
	const getCategories = async () => {
		try {
			const data = { id: localStorage.getItem("frac") };
			const response = await request.post("/commonArea/get/categories", data);
			if (response && !response.error && response.categories && !response.empty) {
				setState((prev) => ({ ...prev, categories: response.categories }));
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		getCategories();
	}, []);

	// Preview de imagen
	const showPreviewImageCommon = (e) => {
		const file = e.target.files[0];
		if (!file) return;
		const reader = new FileReader();
		reader.onloadend = () => {
			handleUpdate({ imagenArea: reader.result });
		};
		reader.readAsDataURL(file);
	};

	const [eine1, setEine1] = useState("");
	const [eine2, setEine2] = useState("");

	const base64ToUrl = async (info) => {
		try {
			const data = {
				img: info.area_imagen,
				idfrac: localStorage.getItem("frac") || 0,
				id: info.id_area,
				module: "areasComunes",
			};

			const response = await request.post("/commonArea/base64ToUrl", data);

			if (response && !response.error) {
				if (info.type === 1) {
					setEine1(response.url);
				}
				if (info.type === 2) {
					setEine2(response.url);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	// Render
	return (
		<CommonAreaForm
			state={state}
			handleUpdate={handleUpdate}
			showPreviewImageCommon={showPreviewImageCommon}
			submitText="ACTUALIZAR"
			editar={true}
		/>
	);
};

export default CommonAreasEdit;
